const DEV_VARS = {
	//storeId: '60da065437950a94f897bec6', // iowa
	//storeId: '614152899ed97ea76b0905de', // popup
	storeId: '6206a77f4224d112304ca97a', // exhibit
	apiUrl: 'https://api.beta.obsess-vr.com/webstore/v1/',
	s3Bucket: 'obsess-cms-beta',
}

module.exports = DEV_VARS
